import { render, staticRenderFns } from "./widget_master_class_overview.vue?vue&type=template&id=035856de&scoped=true&"
import script from "./widget_master_class_overview.vue?vue&type=script&lang=js&"
export * from "./widget_master_class_overview.vue?vue&type=script&lang=js&"
import style0 from "./widget_master_class_overview.vue?vue&type=style&index=0&id=035856de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035856de",
  null
  
)

export default component.exports